module.exports = __webpack_public_path__ + "static/img/ic_qb_search@2x.87f52ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_qb_search@2x.png
// module id = yS/l
// module chunks = 1